"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PluggableElementBase_1 = __importDefault(require("./PluggableElementBase"));
class ConnectionType extends PluggableElementBase_1.default {
    constructor(stuff) {
        super(stuff);
        this.stateModel = stuff.stateModel;
        this.configSchema = stuff.configSchema;
        this.displayName = stuff.displayName;
        this.description = stuff.description;
        this.url = stuff.url;
        this.configEditorComponent = stuff.configEditorComponent;
        if (!this.stateModel) {
            throw new Error(`no stateModel defined for connection ${this.name}`);
        }
        if (!this.configSchema) {
            throw new Error(`no configSchema defined for connection ${this.name}`);
        }
    }
}
exports.default = ConnectionType;
